"use client";
import React from 'react'
import { useLocale } from '@/app/providers/LocalContextProvider';
import { availableLocales } from '@/hooks/useTranslation';
import IconGlowWrapper from '@/app/components/IconGlowWrapper';
import { MdLanguage } from 'react-icons/md';

const LanguageSwitcher = () => {
    const { locale, setLocale } = useLocale();

    const currentLocale = availableLocales.find(l => l.code === locale) || availableLocales[0];

    const handleLanguageChange = (localeCode: string) => {
        setLocale(localeCode);
    };

    const languages = [
        { code: 'ja', label: 'J' },
        { code: 'en', label: 'E' },
        { code: 'de', label: 'D' },
        { code: 'fr', label: 'F' },
        { code: 'tc', label: 'T' },
    ];

    return (
        <div
            className="pointer-events-auto gap-[2px]"
            style={{ display: 'flex', height: '100%', alignItems: 'center' }}
        >
            <IconGlowWrapper
                icon={<MdLanguage />}
                className={` mr-1 text-[22px] pointer-events-none`}
                color="yellow"
            />

            {languages.map(lang => (
                <div
                    key={lang.code}
                    className="relative flex flex-col cursor-pointer "
                    onClick={() => handleLanguageChange(lang.code)}
                >
                    <span className={`text-sm xl:text-base text-shadow font-contrax ${currentLocale.code === lang.code ? 'text-[#FFFBD4] shadow-yellow-800/90' : 'text-[#948d7e] shadow-black/50'}`}>{lang.label}</span>
                    <div
                        className={`absolute bottom-[1px] w-full h-[2px] bg-[#FFFBD4] shadow-[0_0px_4px_2px_rgba(133,77,14,0.8)] ${lang.code === currentLocale.code ? 'opacity-100' : 'opacity-0'}`}
                    ></div>
                </div>
            ))}
        </div>
    )
}

export default LanguageSwitcher